import _slicedToArray from "/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';

var useStickyroll = function useStickyroll(_ref) {
  var _ref$factor = _ref.factor,
      factor = _ref$factor === void 0 ? 1 : _ref$factor,
      pages = _ref.pages;
  var ref = React.useRef();

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      pageIndex = _React$useState2[0],
      setPageIndex = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      progress = _React$useState4[0],
      setProgress = _React$useState4[1];

  var pageCount = typeof pages === "number" ? pages : Array.isArray(pages) && pages.length;
  var handleScroll = React.useCallback(function () {
    var current = ref.current;

    if (current !== undefined) {
      var end = window.innerHeight * -pageCount * factor;

      var _current$getBoundingC = current.getBoundingClientRect(),
          top = _current$getBoundingC.top;

      if (top <= 0 && top >= end) {
        var time = -top / window.innerHeight / factor;
        var nextPageIndex = Math.floor(time);
        var nextProgress = time - nextPageIndex;
        setProgress(nextProgress);
        setPageIndex(nextPageIndex);
      } else if (top < end) {
        setProgress(1);
        setPageIndex(pageCount - 1);
      } else if (top > 0) {
        setProgress(0);
        setPageIndex(0);
      }
    }
  }, [ref, setPageIndex, setProgress, pageCount, factor]);
  React.useEffect(function () {
    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);
  var height = React.useMemo(function () {
    return "".concat(pageCount * factor * 100 + 100, "vh");
  }, [pageCount, factor]);
  var props = {
    currentPage: pageIndex + 1,
    pageCount: pageCount,
    pageIndex: pageIndex,
    progress: progress,
    height: height
  };
  return [ref, props];
};

export { useStickyroll };